import {financeAPI} from "../../axios"

export const actions = {
    addFundSourceFavorite(context, data)
    {
        return financeAPI.post("UserFundSourceFavorite/Add",data)
    },

    getMyFavoriteFundSource(context, {cycle, campusId})
    {
        return financeAPI.get(`UserFundSourceFavorite/My/${cycle}/${campusId}`)
    },

    removeFavoriteFundSource(context, id)
    {
        return financeAPI.delete(`UserFundSourceFavorite/Remove/${id}`)
    }
}